module.exports = __webpack_public_path__ + "img/Bergens_Kapitelsbok_Bergens-miljoet.d76c308a.jpg";